import { render, staticRenderFns } from "./RequestFeedback.vue?vue&type=template&id=631650c4"
import script from "./RequestFeedback.vue?vue&type=script&lang=js"
export * from "./RequestFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports